// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"jq-z","breadcrumbForward":"kq-z","breadcrumbBack":"lq-z","selected":"mq-z"};